var map = {
	"./avatar-action-0001.svg": 732,
	"./avatar-action-0002.svg": 733,
	"./avatar-action-0003.svg": 734,
	"./avatar-action-0004.svg": 735,
	"./avatar-action-0005.svg": 736,
	"./avatar-action-0006.svg": 737,
	"./avatar-action-0007.svg": 738,
	"./avatar-action-0008.svg": 739,
	"./avatar-action-0009.svg": 740,
	"./avatar-action-0010.svg": 741,
	"./avatar-action-0011.svg": 742,
	"./avatar-action-0012.svg": 743
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 731;